import {fetchGet, generateEndpoint} from "../../../utils/request";

export const getMeasurementsAdmin = async(token) => {
  const url = `${generateEndpoint("getMeasurementsAdmin")}`;
  return fetchGet(url, token);
};

export const getGuests = async(token) => {
  const url = `${generateEndpoint("getGuests")}`;
  return fetchGet(url, token);
};
